import fp from 'lodash/fp';

// eslint-disable-next-line import/prefer-default-export
export const getChartDataAdapter = (useDollars = false) => fp.flow(
    fp.map(d => ({
        date: new Date(d.businessDate),
        calc: (useDollars ? d.imPledgeUsd : d.imPledgeEur),
        posted: (useDollars ? d.imPledgorPaymentUsd : d.imPledgorPaymentEur)
    })),
    fp.sortBy('date')
);
